import type { NextPage } from "next"

import UuidGenerator from "@features/generators/uuid"

import Page from "@shared/ui/page"

const UuidGeneratorPage: NextPage = () => {
  return (
    <Page title={"Password and Secret"}>
      <UuidGenerator />
    </Page>
  )
}

export default UuidGeneratorPage
